<tree-view class="no-scroll" [viewMetadata]="viewMetadata" [entities]="entities" [datacontroller]="datacontroller" [model]="model">
</tree-view>

